/**
 * @generated SignedSource<<b2c1318f3c43185ba98536e6c66ac9a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserPropertyFragment$data = {
  readonly properties: {
    readonly property: ReadonlyArray<{
      readonly name: string | null;
      readonly value: string | null;
    }> | null;
  } | null;
  readonly " $fragmentType": "useUserPropertyFragment";
};
export type useUserPropertyFragment$key = {
  readonly " $data"?: useUserPropertyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserPropertyFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserPropertyFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Properties",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Property",
          "kind": "LinkedField",
          "name": "property",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "14bd65424561dd69e1cc06adb98ef687";

export default node;
